const fixNumber = (num) => parseFloat(Number(num).toFixed(2))

export default fixNumber
